import { useQuery } from "@tanstack/react-query";
import { TrustapUserService } from "../../services";
import { asQuery } from "../../services/common";
import { DASH_STALE } from "./shared";

// The signed-in user's Trustap account state (shared by Seller home + the
// Trustap account page). Returns the account object / boolean the API sends.
export function useMyTrustapAccount(token?: string) {
  return useQuery({
    queryKey: ["trustap", "my-account", token],
    queryFn: () =>
      asQuery<any>(TrustapUserService.getMyTrustapAccount(token as string)),
    enabled: !!token,
    staleTime: DASH_STALE,
  });
}

// Whether a connected (full-account) seller's OAuth grant still has every
// offline scope we need: `{ isFullAccount, scopesUpToDate, missingScopes }`.
// A stale grant (scopesUpToDate === false) is what makes Start Shipping /
// Claim Payout 401 — surface it as a "reconnect" banner before they hit it.
export function useTrustapConnectionHealth(token?: string) {
  return useQuery({
    queryKey: ["trustap", "connection-health", token],
    queryFn: () =>
      asQuery<any>(TrustapUserService.getConnectionHealth(token as string)),
    enabled: !!token,
    staleTime: DASH_STALE,
  });
}
